import "@/App.css";
import ZenkoLanding from "@/components/ZenkoLanding";
import { LangProvider } from "@/i18n/LangContext";

function App() {
  return (
    <LangProvider>
      <ZenkoLanding />
    </LangProvider>
  );
}

export default App;
